import { CarouselTypes } from '../consts';

export const container = ({ type, withButtons, theme: { cursors } }) => ({
    flex: type === CarouselTypes.GALLERY && '1',
    display: 'inline-flex',
    flexDirection: 'column',
    zIndex: 2,
    ...cursors.circle,
    marginTop: 2,

    tablet: {
        flexDirection: 'row',
    },

    paddingLeft: withButtons ? '5rem' : 'unset',
    paddingRight: withButtons ? '5rem' : 'unset',
});

export const stepsContainer = {
    display: 'flex',
    alignItems: 'center',
    marginTop: '0.75rem',

    tablet: {
        marginTop: 0,
    },
};

export const title = ({ theme: { fonts } }) => ({
    ...fonts.heroNewBold,
    fontSize: '1rem',
    textTransform: 'uppercase',
    letterSpacing: '0.1875rem',
    marginRight: '1.375rem',
});
